import React, { useEffect, useState } from "react";
import Canvas from "../assets/img/Canvas.svg";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import productStore from "../stores/ProductStore";
import ProductService from "../Services/ProductService";
import productSizeStore from "../stores/ProductSizeStore";
import Header from "../Components/Header";
import CartService from "../Services/CartService";

const headerLinks = [{ name: "Home", href: "/" }];

interface Product {
  productID: number;
  productName: string;
  description: string;
  basePrice: number;
  productTypeId: number;
  imageUrl: string;
  width: number;
  height: number;
  productType: string;
}

const SelectProductSize: React.FC = observer(() => {
  const [productOptions, setProductOptions] = useState<Product[]>([]);
  const [cartItemCount, setCartItemCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch products based on the selected product ID from the store
    const fetchProductSizes = async () => {
      const productTypeId = productStore.getSelectedProductId;
      try {
        if (productTypeId != null) {
          const response = await ProductService.getProductList(productTypeId);
          const productSizes = response.map((item: any) => ({
            productID: item.productID,
            productName: `${item.productName} (${item.description})`,
            description: item.description,
            basePrice: item.basePrice,
            productTypeId: item.productTypeId,
            imageUrl: item.imageUrl,
            width: item.width,
            height: item.height,
            productType:"canvas"
          }));
          setProductOptions(productSizes);
        }
      } catch (error) {
        console.error("Error fetching product sizes:", error);
      }
    };

    fetchProductSizes();
  }, []);

  const handleSizeClick = (product: Product) => {
    // Set the selected product object to the store
    productSizeStore.setSelectedProduct({
      prdWidth: product.width,
      prdHeight: product.height,
      productId: product.productID,
      basePrice: product.basePrice,
      description: product.description,
      productName: product.productName,
      productTypeId: product.productTypeId,
      productType: product.productType
    });

    navigate(process.env.REACT_APP_PublicPath + "/canvasname", { replace: true });
  };
  const fetchCartCount = async () => {
    try {
      const { CartCount } = await CartService.GetCartCount();
      setCartItemCount(CartCount);
    } catch (error) {
      console.error("Error fetching cart count:", error);
    }
  };

  useEffect(() => {
    fetchCartCount(); // Fetch cart count when the component mounts
  }, []);
  return (
    <>
      <Header
        cartItemsCount={cartItemCount}
        title="My Website"
        links={headerLinks}
      />
      <section className="SelectProductSize">
        <div className="mx-auto max-w-7xl mt-10 mb-40 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-normal text-center">
            Select Canvas Size
          </h1>
          <div className="grid grid-cols-4 gap-4 mt-8">
            {productOptions.map((option) => (
              <div
                key={option.productID}
                className="mr-4 mb-4 block max-w-sm px-4 py-8 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100"
              >
                <div className="flex flex-col items-center">
                  <img
                    src={Canvas}
                    alt={`${option.productName}`}
                    className="h-18 w-auto"
                  />
                  <h5 className="mb-1 text-base font-medium text-gray-900 pt-3">
                    {option.width}X{option.height}
                  </h5>
                  <span className="text-gray-600">${option.basePrice}</span>
                  <button
                    className="px-4 py-2 bg-green font-medium text-white rounded-lg shadow mt-2"
                    onClick={() => handleSizeClick(option)}
                  >
                    Personalize
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
});

export default SelectProductSize;
